import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import CodeMirror from '@uiw/react-codemirror';
import { javascript } from '@codemirror/lang-javascript';
import { python } from '@codemirror/lang-python';
import { java } from '@codemirror/lang-java';
import { json } from '@codemirror/lang-json';
import { githubLight, githubDark } from '@uiw/codemirror-theme-github';

const getLanguageExtension = (lang) => {
    switch (lang) {
        case 'javascript':
            return javascript();
        case 'python':
            return python();
        case 'java':
            return java();
        case 'json':
            return json();
        default:
            return javascript();
    }
};

const UserGeneratedCodeMessage = ({ text, iconType, language = 'javascript' }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const backgroundGradient = isDark
        ? 'linear-gradient(to top, rgb(73, 71, 75), rgb(48, 45, 51))'
        : 'linear-gradient(to top, rgba(255, 255, 255, 0.8), rgba(0, 116, 211, 0.1))';

    return (
        <Box
            sx={{
                p: 2,
                mt: 1,
                mb: 1,
                width: '100%',
                overflow: 'hidden',
                borderRadius: 1,
                minHeight: 100,
                background: backgroundGradient,
                boxShadow: 1,
                '& .cm-editor': {
                    width: '100% !important',
                },
            }}
        >
            <CodeMirror
                value={text}
                height="300px"
                editable={false}
                theme={isDark ? githubDark : githubLight}
                extensions={[getLanguageExtension(language)]}
            />
        </Box>
    );
};

export default UserGeneratedCodeMessage;
